import React from 'react'
import { useGetBalanceReportQuery, useGetBlockChainASLQuery } from 'features'
import { ErrorBoundary } from 'components'
import { useParams } from 'react-router-dom'
import { Typography } from '@mui/material'
import { dniFormatter, assetsFormatter } from 'formatters'
import { TransfersReport } from './TransfersReport.jsx'
import { format } from 'date-fns'

export function ViewAStatementByDNIReport() {
  const { dni } = useParams()

  const {
    data: statementTotal,
    isLoading: statementLoading,
    error: statementError,
  } = useGetBalanceReportQuery({
    page: 1,
    limitNumber: 1,
    params: {
      search: dni,
      schoolcycle: new Date().getFullYear,
    },
    paginated: false,
  })

  const {
    data: blockchainASL,
    isLoading: blockchainASLLoading,
    error: blockchainASLError,
  } = useGetBlockChainASLQuery({ params: { userdni: dni } })

  let {
    firstname = '',
    lastname = '',
    schoolcycle = new Date().getFullYear,
    accredited = 0,
    liquidated = 0,
    adjustmentCredit=0,
    adjustmentDebit = 0,
    received = 0,
    liquidatedPending = 0,
    sent = 0,
  } = statementTotal?.rows[0] || {}

  accredited = Number(accredited)
  liquidated = Number(liquidated)
  received = Number(received)
  sent = Number(sent)
  liquidatedPending = Number(liquidatedPending)
  adjustmentCredit = Number(adjustmentCredit)
  adjustmentDebit = Number(adjustmentDebit)

  let total = accredited - liquidated - liquidatedPending + received - sent + adjustmentCredit - adjustmentDebit

  let reportHeader = [
    ['Estado de cuenta'],
    ['Alumno:', firstname + ' ' + lastname],
    ['DNI:', dni],
    ['Ciclo escolar:', schoolcycle],
    ['Fecha:', format(new Date(), 'dd/MM/yyyy')],
    [''][('Saldo actual blockchain:', blockchainASL?.blockchainbalance)],
    ['Saldo a la fecha:', total],
    ['Liquidaciones en proceso:', liquidatedPending],
    [''],
  ]

  if (blockchainASLLoading || statementLoading) {
    return null
  }

  return (
    <div>
      <ErrorBoundary fallback={<div>Error</div>}>
        <div className="flex flex-col justify-start items-stretch mt-32 gap-4 ">
          <div className="border-b border-primary w-full pb-8 flex flex-row justify-between items-start">
            <div>
              <Typography variant="h2" component="p" className="text-primary">
                {firstname} {lastname} - DNI: {dniFormatter(dni)}
              </Typography>
              <Typography variant="h2" component="p" className="text-primary">
                Ciclo lectivo: {schoolcycle}
              </Typography>
            </div>
            <div className="flex flex-col justify-start items-end">
              <Typography variant="h2" component="p" className="text-primary">
                Saldo blockchain:{' '}
                {assetsFormatter(blockchainASL?.blockchainbalance * 100)}
              </Typography>
              <Typography variant="h2" component="p" className="text-primary">
                Saldo backoffice: {assetsFormatter(total * 100)}
              </Typography>
              <Typography variant="h2" component="p" className="text-primary">
                Liquidaciones pendientes:{' '}
                {assetsFormatter(liquidatedPending * 100)}
              </Typography>
            </div>
          </div>
          <TransfersReport embedded={true} reportHeader={reportHeader} />
        </div>
      </ErrorBoundary>
    </div>
  )
}
